import { Component, OnInit } from '@angular/core';
import { TwoWayBoundComponent } from '@app/shared/components/base/two-way-bound.component';
import { ClientUser } from '@app/shared/models/client-user';
import { DrFileMeta, FileUploadStatus } from '@app/shared/models/dr-file';
import { FileActions } from '@app/shared/models/file-actions';
import { ClientMediaType, MediaContainer } from '@app/shared/models/media-container';
import { FileType, FileTypes } from '@app/shared/models/file-type';
import { ContentStoreService } from '@app/core/services/content-store.service';
import { FileUtilityService } from '@app/core/services/file-utility.service';
import { ConfirmModalComponent } from '@app/shared/dialogs/confirm-dialog/confirm-modal.component';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'user-additional-data',
    templateUrl: './user-additional-data.component.html'
})
export class UserAdditionalDataComponent extends TwoWayBoundComponent<ClientUser>
                                         implements OnInit {

    public disabledThumbnailOptions: FileActions[];
    public clientUserMedia: MediaContainer;
    public signatureAndStampFileTypes: FileType[];

    get user() {
        return this.bananaBox;
    }

    get stamp(): DrFileMeta {
        return this.clientUserMedia && this.clientUserMedia.stamp && this.clientUserMedia.stamp.entries && this.clientUserMedia.stamp.entries[0];
    }

    get signature(): DrFileMeta {
        return this.clientUserMedia && this.clientUserMedia.signature && this.clientUserMedia.signature.entries && this.clientUserMedia.signature.entries[0];
    }

    constructor(protected contentStoreService: ContentStoreService,
                protected fileUtilityService: FileUtilityService,
                protected translateService: TranslateService,
                protected dialog: MatDialog) {
        super();
        this.signatureAndStampFileTypes = FileTypes.TYPES_PHOTO.concat(FileTypes.TYPES_IMAGE);
    }

    public ngOnInit() {
        super.ngOnInit();

        this.disabledThumbnailOptions = [FileActions.DOWNLOAD, FileActions.VIEW, FileActions.EDIT];

        this.contentStoreService.getUserMediaFiles(this.bananaBox)
                                .subscribe(result => {
                this.clientUserMedia = result;
            }, err => this.handleError(err));
    }

    public onSignatureFilesSelected(files: File[]): void {
        if (!this.signature && files && files.length > 0) {
            const daSignature = files[0];
            this.uploadUserMediaFile(daSignature, ClientMediaType.SIGNATURE);
        }
    }

    public onStampFilesSelected(files: File[]): void {
        if (!this.stamp && files && files.length > 0) {
            const daStamp = files[0];
            this.uploadUserMediaFile(daStamp, ClientMediaType.STAMP);
        }
    }

    protected uploadUserMediaFile(file: File, type: ClientMediaType) {
        const newFileMeta = new DrFileMeta();
        newFileMeta.filename = file.name;
        newFileMeta.status = FileUploadStatus.LOADING;
        newFileMeta.order = 1;

        this.clientUserMedia.addFile(newFileMeta, type);

        this.fileUtilityService.fileAsBinaryString(file)
            .subscribe((fileAsBinaryString) => {
                this.contentStoreService.addUserMediaFile(this.bananaBox, type, fileAsBinaryString, newFileMeta)
                                        .subscribe((result: DrFileMeta) => {
                            result.status = FileUploadStatus.READY;
                            this.clientUserMedia.replaceFile(result, type);
                        },
                        err => {
                            newFileMeta.status = FileUploadStatus.ERROR;
                            this.clientUserMedia.replaceFile(newFileMeta, type);
                        }
                    );
            });
    }

    public deleteSignature(metaFile: DrFileMeta): void {
        this.deleteUserMediafile(metaFile, ClientMediaType.SIGNATURE);
    }

    public deleteStamp(metaFile: DrFileMeta): void {
        this.deleteUserMediafile(metaFile, ClientMediaType.STAMP);
    }

    protected deleteUserMediafile(fileMeta: DrFileMeta, type: ClientMediaType): void {
        if (fileMeta.id) {
            const dialogRef = this.dialog.open(ConfirmModalComponent, {
                width: '400px',
                data: {
                    title: this.translateService.instant(marker('case.file.delete.title')),
                    text: `${this.translateService.instant(marker('case.file.delete.text'))} '${fileMeta.filename}'?`
                }
            });

            dialogRef.afterClosed()
                     .subscribe((dialogResult: boolean) => {
                if (dialogResult) {
                    this.contentStoreService.deleteUserMediaFile(this.bananaBox, type, fileMeta)
                        .subscribe(result => {
                            this.clientUserMedia.removeFile(fileMeta, type);
                        }, err => this.handleError(err));
                }
            });
        } else {
            this.clientUserMedia.removeFile(fileMeta, type);
        }
    }
}
